(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CAFAttachmentDeleteController',CAFAttachmentDeleteController);

    CAFAttachmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'CAFAttachment'];

    function CAFAttachmentDeleteController($uibModalInstance, entity, CAFAttachment) {
        var vm = this;

        vm.cAFAttachment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CAFAttachment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
